import script from "./BusinessDangerDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./BusinessDangerDialog.vue?vue&type=script&lang=ts&setup=true"

import "./BusinessDangerDialog.vue?vue&type=style&index=0&id=17235414&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17235414"]])

export default __exports__